'use strict'

const saveStates = {
  SAVE_STATE_NONE: 'SAVE_STATE_NONE',
  SAVE_STATE_CALL_BEFORE_SAVE_HOOKS: 'SAVE_STATE_CALL_BEFORE_SAVE_HOOKS',
  SAVE_STATE_CHECK_HAS_DRAFT: 'SAVE_STATE_CHECK_HAS_DRAFT',
  SAVE_STATE_ASSERT_VALIDITY: 'SAVE_STATE_ASSERT_VALIDITY',
  SAVE_STATE_SAVE_RECORD: 'SAVE_STATE_SAVE_RECORD',
  SAVE_STATE_SEND_AUTOMATIONS_EVENT: 'SAVE_STATE_SEND_AUTOMATIONS_EVENT',
  SAVE_STATE_ERROR: 'SAVE_STATE_ERROR'
}

const isNone = saveState => saveState === saveStates.SAVE_STATE_NONE
const isError = saveState => saveState === saveStates.SAVE_STATE_ERROR
const isAssertValidity = saveState =>
  saveState === saveStates.SAVE_STATE_ASSERT_VALIDITY
const isCallBeforeSaveHooks = saveState =>
  saveState === saveStates.SAVE_STATE_CALL_BEFORE_SAVE_HOOKS
const isCheckHasDraft = saveState =>
  saveState === saveStates.SAVE_STATE_CHECK_HAS_DRAFT
const isSaveRecord = saveState =>
  saveState === saveStates.SAVE_STATE_SAVE_RECORD
const isSendAutomationEvent = saveState =>
  saveState === saveStates.SAVE_STATE_SEND_AUTOMATIONS_EVENT
const isDuringSave = saveState =>
  saveState !== saveStates.SAVE_STATE_NONE &&
  saveState !== saveStates.SAVE_STATE_ERROR

module.exports.saveStates = saveStates

module.exports.isNone = isNone
module.exports.isError = isError
module.exports.isAssertValidity = isAssertValidity
module.exports.isCallBeforeSaveHooks = isCallBeforeSaveHooks
module.exports.isCheckHasDraft = isCheckHasDraft
module.exports.isSaveRecord = isSaveRecord
module.exports.isSendAutomationEvent = isSendAutomationEvent
module.exports.isDuringSave = isDuringSave



// WEBPACK FOOTER //
// ./records/saveStates.js